import styled, { css } from 'styled-components';
import { Display } from '../../theme/Display';
import { Spacing } from '../../theme/Spacing';
var StyledLink = styled.a.withConfig({
  displayName: "StyledLink",
  componentId: "dp0opy-0"
})(["", ";", ";font-family:", ";text-decoration:none;cursor:pointer;font-style:normal;font-weight:500;display:flex;align-items:center;", " ", " ", " ", " ", " ", ""], Display, Spacing, function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && css(["pointer-events:none;"]);
}, function (_ref3) {
  var theme = _ref3.theme,
    variant = _ref3.variant;
  return variant === 'primary' && css(["color:", ";&:hover,&:focus,&:active{color:", ";}svg,svg path{fill:", ";}"], theme.colors.blue600, theme.colors.blue900, theme.colors.blue600);
}, function (_ref4) {
  var theme = _ref4.theme,
    variant = _ref4.variant,
    disabled = _ref4.disabled;
  return variant === 'primary' && disabled && css(["color:", ";"], theme.colors.gray600);
}, function (_ref5) {
  var theme = _ref5.theme,
    variant = _ref5.variant;
  return variant === 'danger' && css(["color:", ";&:hover,&:focus,&:active{color:", ";}svg,svg path{fill:", ";}"], theme.colors.red500, theme.colors.red900, theme.colors.red500);
}, function (_ref6) {
  var theme = _ref6.theme,
    variant = _ref6.variant;
  return variant === 'darkMode' && css(["color:", ";&:hover,&:focus{color:", ";}&:active{color:", ";}svg,svg path{fill:", ";}"], theme.colors.white, theme.colors.gray500, theme.colors.gray400, theme.colors.white);
}, function (_ref7) {
  var theme = _ref7.theme,
    variant = _ref7.variant,
    disabled = _ref7.disabled;
  return variant === 'darkMode' && disabled && css(["color:", ";"], theme.colors.gray7);
});
var MDLink = styled(StyledLink).withConfig({
  displayName: "StyledLink__MDLink",
  componentId: "dp0opy-1"
})(["font-size:12px;line-height:18px;letter-spacing:-0.1px;"]);
var LGLink = styled(StyledLink).withConfig({
  displayName: "StyledLink__LGLink",
  componentId: "dp0opy-2"
})(["font-size:14px;line-height:20px;letter-spacing:-0.2px;"]);
export { MDLink, LGLink };